import { render, staticRenderFns } from "./StockTakeProject.vue?vue&type=template&id=4576416e&scoped=true"
import script from "./StockTakeProject.vue?vue&type=script&lang=js"
export * from "./StockTakeProject.vue?vue&type=script&lang=js"
import style0 from "./StockTakeProject.vue?vue&type=style&index=0&id=4576416e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4576416e",
  null
  
)

export default component.exports